import {
  Lazy, Navigation, Pagination, Swiper, A11y,
} from 'swiper';

let lastOpenedOffer = null;
const isSafari = navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') === -1;

function safariFocusOnLastOpenedOffer() {
  if (isSafari) {
    const lastOfferLink = lastOpenedOffer?.querySelector('.item-offer__button');
    if (lastOfferLink !== null) {
      lastOfferLink?.focus();
    }
  }
}
function safariFocusOnSliderElements(e) {
  if (isSafari) {
    const prevFocusableEl = e.target;
    setTimeout(() => prevFocusableEl.focus(), 10);
  }
}

function safariFocusOnOfferInfo(offer) {
  if (isSafari) {
    lastOpenedOffer = offer;
    const offerSlider = offer.querySelector('.swiper-button-prev');
    if (offerSlider) {
      offerSlider.focus();
    } else {
      const openedInfoBlock = offer.nextElementSibling;
      const viewInfoLink = openedInfoBlock.querySelector('.item-offer-details__button');
      viewInfoLink.focus();
    }
  }
}

function closeItems(block) {
  block.querySelectorAll('.item-offer').forEach((item) => {
    if (item.querySelector('.item-offer__text')) {
      if (item.querySelector('.offer-slider__navigation')) {
        item.querySelector('.offer-slider__navigation').classList.add('d-none');
      }
      item.querySelector('.item-offer__text').classList.remove('d-none');
      item.querySelector('.item-offer__slider').classList.remove('active');
      item.querySelector('.item-offer__blackout').classList.remove('item-offer__blackout--active');
      item.querySelector('.item-offer__diamond').classList.add('d-none');
      block.querySelectorAll('.item-offer-details').forEach((details) => {
        details.classList.add('d-none');
      });
    }
  });

  safariFocusOnLastOpenedOffer();
}

if (window.innerWidth >= 768) {
  window.addEventListener('resize', () => {
    document.querySelectorAll('.offers-block').forEach((block) => {
      closeItems(block);
    });
  });
}

if (window.innerWidth <= 992) {
  document.querySelectorAll('.offers-block').forEach((block) => {
    const blocksWithAnimation = block.querySelectorAll('.c-appeared');
    blocksWithAnimation.forEach((animationEl) => {
      animationEl.classList.remove('c-appeared', 'c-appeared--down');
    });
  });
}

function setCount() {
  const width = window.innerWidth;

  switch (true) {
    case width < 1200 && width > 992:
      return 2;
    case width < 992:
      return 1;
    default:
      return 3;
  }
}

function openItem(block, index, offer) {
  offer.querySelector('.item-offer__text').classList.add('d-none');
  if (offer.querySelector('.offer-slider__navigation')) {
    offer.querySelector('.offer-slider__navigation').classList.remove('d-none');
  }
  offer.querySelector('.item-offer__blackout').classList.add('item-offer__blackout--active');
  offer.querySelector('.item-offer__slider').classList.add('active');
  offer.querySelector('.item-offer__diamond').classList.remove('d-none');
  const selectedIndex = block.querySelectorAll('.item-offer-details')[index];
  selectedIndex.classList.remove('d-none');
  selectedIndex.style.order = setCount() * Math.ceil((index + 1) / setCount()) + 1;

  if (window.location.hash !== `#${offer.id}`) {
    window.location.hash = offer.id;
  }

  safariFocusOnOfferInfo(offer);
}

const offersBlock = window.document.querySelectorAll('.offers-block');
const offerSlider = window.document.querySelectorAll('.offer-slider');

window.document.addEventListener('DOMContentLoaded', () => {
  offersBlock.forEach((block) => {
    block.querySelectorAll('.item-offer-details').forEach((offerDetails) => {
      offerDetails.querySelector('.item-offer-details__close').addEventListener('click', (event) => {
        event.preventDefault();
        closeItems(block, offerDetails);
      });
    });

    block.querySelectorAll('.item-offer').forEach((slider, index) => {
      // eslint-disable-next-line no-param-reassign
      slider.style.order = index + 1;
      slider.addEventListener('click', function () {
        closeItems(block);
        openItem(block, index, this);
      });

      slider.addEventListener('keydown', function (event) {
        if (event.keyCode === 13) {
          closeItems(block);
          openItem(block, index, this);

          safariFocusOnSliderElements(event);
        }
      });
    });
  });

  offerSlider.forEach((slider) => {
    if (slider.querySelectorAll('.swiper-slide').length <= 1) {
      return;
    }

    const swiper = new Swiper(slider, {
      lazy: true,
      loop: true,
      autoHeight: true,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
      pagination: {
        clickable: true,
        el: '.offer-slider__pagination',
      },
      modules: [Lazy, Pagination, Navigation, A11y],
    });

    slider.querySelectorAll('.swiper-pagination-bullet').forEach((bullet, index) => {
      bullet.setAttribute('tabindex', 0);
      bullet.setAttribute('data-slide-id', index);
      bullet.addEventListener('keydown', function (event) {
        if (event.keyCode === 13) {
          const slideID = this.getAttribute('data-slide-id');
          swiper.slideToLoop(slideID);
        }
      });
    });
  });
});

window.document.addEventListener('DOMContentLoaded', () => {
  if (window.location.hash) {
    const anchor = document.querySelector(window.location.hash);
    if (anchor) {
      anchor.click();
    }
  }
});

window.addEventListener('hashchange', () => {
  const anchor = window.document.querySelector(window.location.hash);
  if (anchor) {
    anchor.click();
  }
});
